export default {
  bind(el, binding) {
    const userInfo = window.localStorage.getItem("okr_userInfo") || "{}";
    const user = JSON.parse(userInfo).value || {};
    binding.value = binding.value || {};
    function addWaterMarker(
      // str = user["name"] + " " + (user["last_4_phone"] || "****"),
      parentNode,
      font,
      textColor,
      zIndex,
      str = user["name"] + " " + (user["last_4_phone"] || "****")
    ) {
      // 水印文字，父元素，字体，文字颜色
      const can = document.createElement("canvas");
      parentNode.appendChild(can);
      can.width = 320;
      can.height = 160;
      can.style.display = "none";
      const cans = can.getContext("2d");
      cans.rotate((-20 * Math.PI) / 180);
      cans.font = font || 14 * 2 + "px Microsoft YaHei";
      cans.fillStyle = textColor || "rgba(139, 140, 140, 0.15)";
      cans.textAlign = "left";
      cans.textBaseline = "middle";
      cans.fillText(str, can.width / 10, can.height / 1);

      const watertDom = document.createElement("div");

      if (
        !window.getComputedStyle(parentNode, null).position ||
        window.getComputedStyle(parentNode, null).position == "static" ||
        window.getComputedStyle(parentNode, null).position == "initial"
      ) {
        parentNode.style.position = "relative";
      }
      watertDom.style.position = "absolute";
      watertDom.style.left = "0";
      watertDom.style.top = "0";
      parentNode.addEventListener("scroll", () => {
        watertDom.style.transform =
          "translateY(" + parentNode.scrollTop + "px)";
      });
      watertDom.style.width = "100%";
      watertDom.style.height = "100%";
      watertDom.style.userSelect = "none";
      watertDom.style.pointerEvents = "none";
      watertDom.style.zIndex = zIndex || "9999";
      watertDom.style.backgroundImage =
        "url(" + can.toDataURL("image/png") + ")";
      parentNode.appendChild(watertDom);
      watertDom.style.backgroundSize = "160px 80px";
    }
    setTimeout(() => {
      addWaterMarker(
        el,
        binding.value.font,
        binding.value.textColor,
        binding.value.zIndex,
        binding.value.text
      );
    });
  }
};
